(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
    swiper: '[data-swiper]',
    pagination: '[data-pagination]',
    prev: '[data-button-prev]',
    next: '[data-button-next]',
    lightbox: '[data-lightbox]',
    lightboxImage: '[data-lightbox-image]',
    lightboxClose: '[data-lightbox-close]',
    lightboxPrev: '[data-lightbox-prev]',
    lightboxNext: '[data-lightbox-next]'
}

        subscriptions = {
            'variant:update': '_onVariantChange'
        }

        render() {
    this._initSwiper();
    this._initLightbox();
    this._subscribe('variant:update');
}

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
    autoHeight: false,
    pagination: {
        el: this.$pagination,
        type: 'bullets'
    },
    navigation: {
        prevEl: this.$prev,
        nextEl: this.$next
    },
    breakpoints: {
        992: {
            allowTouchMove: false
        }
    }
});
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }
        }
_initLightbox() {
    const lightbox = this.$lightbox;
    const lightboxImage = this.$lightboxImage;
    const lightboxClose = this.$lightboxClose;
    const lightboxPrev = this.$lightboxPrev;
    const lightboxNext = this.$lightboxNext;

    if (!lightbox) return;

    const slides = Array.from(this.querySelectorAll('[data-lightbox-src]'));
    let currentIndex = 0;

    const showImage = (index) => {
    if (!slides.length) return;

    lightbox.classList.remove('is-zoomed');
    lightbox.scrollTo(0, 0);

    currentIndex = (index + slides.length) % slides.length;
        const slide = slides[currentIndex];

        lightboxImage.src = slide.dataset.lightboxSrc;
        lightboxImage.alt = slide.dataset.lightboxAlt || '';
    };

    const openLightbox = (slide) => {
        currentIndex = slides.indexOf(slide);
        showImage(currentIndex);

        if (lightbox.parentElement !== document.body) {
            document.body.appendChild(lightbox);
        }

        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
    lightbox.classList.remove('is-zoomed');
    lightbox.scrollTo(0, 0);
    lightbox.hidden = true;
    document.body.style.overflow = '';
};

    this.$swiper.addEventListener('click', (event) => {
        const slide = event.target.closest('[data-lightbox-src]');
        if (!slide) return;

        openLightbox(slide);
    });

    lightboxClose.addEventListener('click', closeLightbox);

    lightboxPrev.addEventListener('click', () => {
        showImage(currentIndex - 1);
    });

    lightboxNext.addEventListener('click', () => {
        showImage(currentIndex + 1);
    });
lightboxImage.addEventListener('click', (event) => {
    event.stopPropagation();

    const isZoomed = lightbox.classList.toggle('is-zoomed');

    if (isZoomed) {
        requestAnimationFrame(() => {
            lightbox.scrollTo({
                left: Math.max(0, (lightbox.scrollWidth - lightbox.clientWidth) / 2),
                top: Math.max(0, (lightbox.scrollHeight - lightbox.clientHeight) / 2)
            });
        });
    } else {
        lightbox.scrollTo(0, 0);
    }
});
    lightbox.addEventListener('click', (event) => {
        if (event.target.closest('[data-lightbox-image], [data-lightbox-prev], [data-lightbox-next], [data-lightbox-close]')) return;
        closeLightbox();
    });

    document.addEventListener('keydown', (event) => {
        if (lightbox.hidden) return;

        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
        if (event.key === 'ArrowRight') showImage(currentIndex + 1);
    });
}
        _onVariantChange(data) {
            if(data?.imagePosition) {
                this.swiper.slideTo(data.imagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();